import IconButton from '@mui/material/IconButton';
import { toastr } from 'react-redux-toastr';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import Modal from '@material-ui/core/Modal';
import { Button } from '@mui/material';
import API from '../../../../create/api';
import React, { useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import * as helper from '../../../../../helper/index';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

interface AddtoBalanceProps {
  parcels: Array<{
    id: number;
    addToBalance: boolean;
  }>;
  refreshParcel: () => void;
}

export default function AddtoBalance({ parcels, refreshParcel }: AddtoBalanceProps) {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = React.useState(false);
  const [isProcessing, setIsProcessing] = React.useState(false);
  const [progress, setProgress] = React.useState(0);

  const handleClose = () => {
    if (!isProcessing) {
      setModalOpen(false);
    }
  };
  const parcelIds = useMemo(
    () => parcels.filter((parcel) => !parcel.addToBalance).map((parcel) => parcel.id),
    [parcels],
  );

  const addToBalanceAction = async () => {
    setIsProcessing(true);
    const batchSize = 5;
    const totalParcels = parcelIds.length;
    let processed = 0;

    try {
      // Process parcels in batches of 5
      for (let i = 0; i < totalParcels; i += batchSize) {
        const batch = parcelIds.slice(i, i + batchSize);

        // Process all parcels in current batch concurrently
        await Promise.all(
          batch.map(async (id) => {
            await API.update(`${process.env.REACT_APP_API_SERVER}/parcels`, id, { addToBalance: true })
              .then((res) => {
                toastr.success('Parcel Updated', `Parcel ID:${id ?? ''} Add to Balance`);
              })
              .catch((error) => {
                helper.axiosErrorHandling(error);
              });
          }),
        );

        processed += batch.length;
        setProgress(Math.floor((processed / totalParcels) * 100));
      }
    } finally {
      setIsProcessing(false);
      setModalOpen(false);
      refreshParcel();
    }
  };

  return (
    <>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={modalOpen}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className={`bg-white p-4 m-10`}>
          <h1 id="spring-modal-title">Add to Balance</h1>
          <p id="spring-modal-description">
            <div style={{ height: '60vh' }} className="overflow-auto">
              {isProcessing ? (
                <div>
                  <p>Processing parcels in batches of 5... {progress}% complete</p>
                  <div className="w-full bg-gray-200 rounded-full h-2.5">
                    <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${progress}%` }}></div>
                  </div>
                </div>
              ) : (
                <div>Do you want to Add to Balance {parcelIds.join(', ')}</div>
              )}
            </div>
            <br />
            <Button color="secondary" onClick={addToBalanceAction} disabled={isProcessing}>
              {isProcessing ? 'Processing...' : 'Yes'}
            </Button>
            <Button color="primary" onClick={handleClose} disabled={isProcessing}>
              No
            </Button>
          </p>
        </div>
      </Modal>
      <IconButton
        onClick={() => {
          setModalOpen(true);
        }}
      >
        <AccountBalanceOutlinedIcon style={{ color: '#2e7d32' }} />
      </IconButton>
    </>
  );
}
